require('jqvmap/dist/jquery.vmap.min');
require('jqvmap/dist/maps/jquery.vmap.world');
require('jqvmap/dist/jqvmap.min.css');

class PaymentIntegrationsPage {

    constructor(options) {
        this.options = $.extend({
            paymentGatewaysSection: $('.payment-integrations'),
            paymentCountry: $('.payment-integrations-country'),
            paymentMethod: $('.payment-integrations-country__method'),
            countryList: $('#country-list'),
            countryItem: $('.payment-integrations__countries-item a'),
            countrySearchList: $('.payment-integrations__search-list'),
            countrySearchInput: $('.payment-integrations__search-input'),
            countrySearchItem: $('.payment-integrations__search-item a'),
            countryTitleName: $('#country-name')
        }, options);

        this._initSortCountries();
        this._initEvents();
        this._filterBySearch();

        if (this.options.selectedCountry) {
            this.showCountryOnMap(this.options.selectedCountry.id);
            this.showCountryInfo(
                this.options.selectedCountry.id,
                this.options.selectedCountry.name
            );
            this._scrollToElement(this.options.paymentCountry, 700);
        } else {
            this.showCountryList();
        }
    }

    _initEvents() {

        let instance = this;

        // Hide countries dropdown on init
        this.options.countrySearchList.hide();

        // // Hide map view
        // this.options.paymentCountry.hide();

        // Click outside search input closes country list dropdown
        $(document).click(function (event) {
            let target = $(event.target);

            if (!target.closest(instance.options.countrySearchInput).length) {
                instance.options.countrySearchList.hide();
            }
        });

        // Click on country item from list & dropdown opens country data
        this.options.countryItem.on('click', this.showCountryOnClick.bind(this));
        this.options.countrySearchItem.on('click', this.showCountryOnClick.bind(this));

        // Click on search input shows country list dropdown
        this.options.countrySearchInput.on('click', function () {
            instance.options.countrySearchList.show();
        });

        window.onpopstate = function(event) {
            if (event.state && event.state.countryId) {
                instance.showCountryOnMap(event.state.countryId);
                instance.showCountryInfo(event.state.countryId, event.state.countryName);
            } else {
                instance.showCountryList();
            }
        }
    }

    // Show country data on click
    showCountryOnClick(event) {
        let countryId = $(event.currentTarget).attr('data-id');
        let countryName = $(event.currentTarget).attr('data-name');

        this.showCountryOnMap(countryId);
        this.showCountryInfo(countryId, countryName, true);

        return false;
    }

    // Show country on a map
    showCountryOnMap(country) {
        this.options.paymentGatewaysSection.addClass('hidden').removeClass('shown');
        this.options.paymentCountry.addClass('shown').removeClass('hidden');

        // Clean map html wrapper to prevent wrong country highlighting
        $('#vmap').html('');
        this.initMap(country);
        this._scrollToElement(this.options.paymentCountry, 700);
        $('.payment-integrations-country').addClass('section--' + country);

        // Show "Not available" banner for Rus
        if( country == 'RU' ){
            $('.rus-war-ship').removeClass('hidden');
            $('.payment-integrations-country__methods').addClass('payment-integrations-country__methods--na');

        } else {
            $('.rus-war-ship').addClass('hidden');
            $('.payment-integrations-country__methods').removeClass('payment-integrations-country__methods--na');
        }
    }

    // Show country list
    showCountryList() {
        this.options.paymentGatewaysSection.addClass('shown').removeClass('hidden');
        this.options.paymentCountry.addClass('hidden').removeClass('shown');
        this._scrollToElement(this.options.paymentCountry, 700);
    }

    // Show country info with payment methods
    showCountryInfo(countryId, countryName, replaceHistory) {
        let url = this.options.url;
        if (replaceHistory && window.history && window.history.replaceState) {
            window.history.pushState({
                countryId: countryId,
                countryName: countryName
            }, '', `${url}/${countryId}`);
        }

        let integrations = this.options.integrations;
        let paymentMethod = this.options.paymentMethod;

        paymentMethod.hide();

        this.options.countryTitleName.text(countryName);

        for (let integration of integrations) {
            if (integration.countries.indexOf(countryId) >= 0) {
                paymentMethod.filter('[data-key="' + integration.key + '"]').show();
            }

            // Show "Not available" banner for Rus
            if(countryId == 'RU'){
                paymentMethod.hide();
            }
        }
    }

    // Filter countries in dropdown by input keyup
    _filterBySearch() {
        let instance = this;

        this.options.countrySearchInput.on('keyup', function () {
            let filterValue = $(this).val().toUpperCase();
            let countryItem = instance.options.countrySearchItem;

            countryItem.each(function () {
                let countryItemTextValue = $(this).text().toUpperCase();
                if (countryItemTextValue.indexOf(filterValue) > -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        });
    }

    // Sort countries by first letter and show it in the beginning of the list;
    _initSortCountries() {
        let firstLetter = "A";
        let countryList = this.options.countryList.children();

        countryList.prepend(`<span class="payment-integrations__countries-letter p">${firstLetter}</span>`);

        this.options.countryItem.each(function () {
            let currentName = $(this).text().trim();

            if (currentName[0] !== firstLetter) {
                firstLetter = currentName[0];
                $(this).before(`<span class="payment-integrations__countries-letter p">${firstLetter}</span>`);
            }
        });
    }

    // Create map with selected country from list
    initMap(selectedCountry) {
        $('#vmap').vectorMap({
            map: 'world_en',
            selectedRegions: selectedCountry,
            backgroundColor: '#FFF',
            borderWidth: 0,
            color: '#D7DFEF',
            hoverColor: false,
            hoverOpacity: null,
            normalizeFunction: 'linear',
            selectedColor: '#00AEF2',
            enableZoom: false,
            showTooltip: false,
            onRegionClick: function (event, code, region) {
                event.preventDefault();
            }
        });
    }

    _scrollToElement(element, speed) {
        if (!speed) {
            speed = 300;
        }

        $('html, body').animate({scrollTop: element.offset().top}, speed);
    }
}

global.PaymentIntegrationsPage = PaymentIntegrationsPage;